import React, { useEffect } from 'react';
import { Box } from '@mui/material';
import useUsers from '../../context/UsersContext';
import { masterDataImportConfig } from '../../config/masterDataImport';
import ImportCard from './CompanyBankImport';
import { sxConfig } from './masterDataImport.style';

export const MasterDataImportPage = () => {
  const { getUser, user } = useUsers();

  useEffect(() => {
    if (!Object.keys(user).length) getUser();
  }, []);

  return (
    <Box sx={sxConfig.container}>
      <Box sx={sxConfig.wrapper}>
        {masterDataImportConfig.map((configItem) => (
          <ImportCard key={configItem.key} item={configItem} />
        ))}
      </Box>
    </Box>
  );
};
